export default {
  app: {
    featured: 'Tiêu biểu',
    random: 'Ngẫu nhiên',
    explore: 'Khám phá',
    keywords: 'Từ khóa',
    search: 'Tìm kiếm',
  },
  explore: {
    filters: 'Lọc',
    resetFilters: 'Đặt lại bộ lọc',
    addKeyword: 'Thêm từ khóa',
  },
  recipe: {
    contributedBy: 'Đóng góp bởi',
    ingredients: 'Nguyên liệu',
    directions: 'Cách làm',
    fullRecipe: 'Xem toàn bộ công thức tại',
    similarDrinks: 'Đồ uống tương tự',
  },
  featuredRecipes: {
    loadMore: 'Tải thêm',
  },
  recipeFind: {
    filterBy: 'Lọc theo',
    name: 'Tên',
    ingredients: 'Nguyên liệu',
    keywords: 'Từ khóa',
    searchForIngredients:
      'Khi tìm kiếm với nhiều nguyên liệu thì các nguyên liệu phải cách nhau bởi một khoảng trắng',
    searchForKeywords:
      'Khi tìm kiếm với nhiều từ khóa thì các từ khóa phải cách nhau bởi một khoảng trắng',
  },
  recipeList: {
    viewRecipe: 'Xem công thức',
  },
  recipeToolbar: {
    print: 'In',
    share: 'Chia sẻ',
    shareOnFacebook: 'Chia sẻ trên Facebook',
    shareOnTwitter: 'Chia sẻ trên Twitter',
    copyURL: 'Sao chép URL',
    hideImage: 'Ẩn hình ảnh',
  },
  favorites: {
    removeAllFavorites: 'Xóa tất cả các mục yêu thích',
    noFavoriteDrinks: 'Bạn chưa có đồ uống yêu thích',
    removeFavoritesPrompt: 'Bạn có chắc là muốn xóa tất cả các mục yêu thích?',
    delete: 'Xóa',
    cancel: 'Hủy bỏ',
  },
  keywordList: {
    enterYourKeyword: 'Nhập từ khóa của bạn',
  },
  search: {
    findYourDrink: 'Tìm đồ uống của bạn',
  },
  pageNotFound: {
    pageNotFound: 'Trang bạn đang tìm kiếm không tồn tại.',
    backToHome: 'Quay lại trang chủ',
  },
};
